import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({ typeIcon, size, className }) => {

    const icon = getIcion(typeIcon, size, className);

    return (
        <>
            {icon}
        </>
    );

};

Icon.propTypes = {
    typeIcon: PropTypes.string.isRequired,
    size: PropTypes.string,
    className: PropTypes.string
};

function getIcion(typeIcon, size, className) {

    let icon;

    if (className === undefined || className === null) {
        className = "";
    }

    if (typeIcon) {
        switch (typeIcon) {

            case "houseFill":
                icon = <i className={`bi bi-house-door-fill ${className}`} style={{ fontSize: size }} />;
                break;

            case "bagFill":
                icon = <i className={`bi bi-bag-fill ${className}`} style={{ fontSize: size }} />;
                break;

            case "cartFill":
                icon = <i className={`bi bi-cart-fill ${className}`} style={{ fontSize: size }} />;
                break;

            case "briefcaseFill":
                icon = <i className={`bi bi-briefcase-fill ${className}`} style={{ fontSize: size }} />;
                break;

            case "dollar":
                icon = <i className={`bi bi-currency-dollar ${className}`} style={{ fontSize: size }} />;
                break;

            case "headset":
                icon = <i className={`bi bi-headset ${className}`} style={{ fontSize: size }} />;
                break;

            case "chatFill":
                icon = <i className={`bi bi-chat-fill ${className}`} style={{ fontSize: size }} />;
                break;

            case "personBoundingBox":
                icon = <i className={`bi bi-person-bounding-box ${className}`} style={{ fontSize: size }} />;
                break;

            case "notification":
                icon = <i className={`bi bi-bell-fill nav-items-icon ${className}`} style={{ fontSize: size }} />;
                break;
            case "iconInvoices":
                icon = <i className={`bi bi-file-earmark-text ${className}`} style={{ fontSize: size }} />;
                break;

            case "search":
                icon = <i className={`bi bi-search nav-items-icon ${className}`} style={{ fontSize: size }} />;
                break;

            case "searchSimple":
                icon = <i className={`bi bi-search ${className}`} style={{ fontSize: size }} />;
                break;

            case "plus":
                icon = <i className={`bi bi-plus nav-items-icon ${className}`} style={{ fontSize: size }} />;
                break;

            case "close":
                icon = <i className={`bi bi-x-lg nav-items-icon ${className}`} style={{ fontSize: size }} />;
                break;

            case "checkAll":

                icon = <i className={`bi bi-check-all nav-items-icon ${className}`} style={{ fontSize: size }} />;
                break;

            case "house":
                icon = <i className={`bi bi-house-door ${className}`} style={{ fontSize: size }} />;
                break;

            case "bag":
                icon = <i className={`bi bi-bag ${className}`} style={{ fontSize: size }} />;
                break;

            case "dashBoard":
                icon = <i className={`bi bi-grid ${className}`} style={{ fontSize: size }} />;
                break;

            case "cart":
                icon = <i className={`bi bi-cart ${className}`} style={{ fontSize: size }} />;
                break;

            case "briefcase":
                icon = <i className={`bi bi-briefcase ${className}`} style={{ fontSize: size }} />;
                break;

            case "person":
                icon = <i className={`bi bi-person ${className}`} style={{ fontSize: size }} />;
                break;

            case "logOut":
                icon = <i className={`bi bi-box-arrow-left ${className}`} style={{ fontSize: size }} />;
                break;

            case "clockwise":
                icon = <i className={`bi bi-arrow-clockwise ${className}`} style={{ fontSize: size }} />;
                break;

            case "squareFill":
                icon = <i className={`bi bi-square-fill ${className}`} style={{ fontSize: size }} />;
            break;

            case "square":
                icon = <i className={`bi bi-square ${className}`} style={{ fontSize: size }} />;
            break;

            case "questionCircleFill":
                icon = <i className={`bi bi-question-circle-fill ${className}`} style={{ fontSize: size }} />;
            break;

            case "boxSeam":
                icon = <i className={`bi bi-box-seam ${className}`} style={{ fontSize: size }} />;
            break;

            case "chat":
                icon = <i className={`bi bi-chat-left-dots ${className}`} style={{ fontSize: size }} />;
            break;

            case "setting":
                icon = <i className={`bi bi-gear ${className}`} style={{ fontSize: size }} />;
            break;

            case "shop":
                icon = <i className={`bi bi-shop ${className}`} style={{ fontSize: size }} />;
            break;

            case "shop-window":
                icon = <i className={`bi bi-shop-window ${className}`} style={{ fontSize: size }} />;
            break;

            case "tools":
                icon = <i className={`bi bi-tools ${className}`} style={{ fontSize: size }} />;
            break;

            case "back":
                icon = <i className={`bi bi-arrow-left ${className}`} style={{ fontSize: size }} />;
            break;

            case "taxes":
                icon = <i className={`bi bi-bank2 ${className}`} style={{ fontSize: size }} />;
            break;

            case "ui-checks-grid":
                icon = <i className={`bi bi-ui-checks-grid ${className}`} style={{ fontSize: size }} />;
            break;

            case "person-fill":
                icon = <i className={`bi bi-person-fill ${className}`} style={{ fontSize: size }} />;
            break;

            case "person-circle":
                icon = <i className={`bi bi-person-circle ${className}`} style={{ fontSize: size }} />;
            break;

            case "people-fill":
                icon = <i className={`bi bi-people-fill ${className}`} style={{ fontSize: size }} />;
            break;

            case "bar-chart-fill":
                icon = <i className={`bi bi-bar-chart-fill ${className}`} style={{ fontSize: size }} />;
            break;

            case "wrench-adjustable":
                icon = <i className={`bi bi-wrench-adjustable ${className}`} style={{ fontSize: size }} />;
            break;

            default:
                icon = <i className={`bi bi-bootstrap ${className}`} style={{ fontSize: size }} />;
                break;
        }
    }

    return icon;

};
